import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Examinees, Training } from '../app.urls';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
// import { ResponseContentType, RequestOptions } from '@angular/http';


@Injectable({
  providedIn: 'root'
})
export class ExamineesService {

  // variable declaration
  private errorResponseSubject: BehaviorSubject<any>;
  errorResponseSubjectObservable: Observable<any>;

  private newExaminee = new BehaviorSubject<any>('');
  public getNewExamineeData = this.newExaminee.asObservable();

  constructor(private http: HttpClient) {
    this.errorResponseSubject = new BehaviorSubject<any>('');
    this.errorResponseSubjectObservable = this.errorResponseSubject.asObservable();
  }

  newExamineeList(examinee: any) {
    this.newExaminee.next(examinee);
  }

  getExaminees(): Observable<any> | null {
    return this.http.get<any>(Examinees.GetExaminees)
  }


  getExamineeByID(examineeuuId: number): Observable<any> | null {
    return this.http.get<any>(Examinees.editExaminee + examineeuuId + '/details')
  }

  getExamineesFilter(options: any): Observable<any> | null {
    return this.http.get<any>(Examinees.ExamineesFilter + '?' + options)
  }

  createNewExaminee(dataToApi: any) {
    const currentUserFromStorage = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
    const clientuuId = currentUserFromStorage.clientuuId;

    dataToApi.clientuuId = clientuuId;
    return this.http.post<any>(Examinees.addExaminees, JSON.stringify(dataToApi), { 'headers': { 'content-type': 'application/json' } })
  }

  editExaminee(dataToApi: any, examineeuuid: number) {
    return this.http.put<any>(Examinees.editExaminee + examineeuuid, JSON.stringify(dataToApi), { 'headers': { 'content-type': 'application/json' } })
  }

  downloadExamineeTemplate(): Observable<any> | null {
    return this.http.get<any>(Examinees.downloadExamineeTemplate)
  }


  DownloadFile(filePath: string, fileType: string): Observable<any> {
    const currentUserFromStorage = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
    const accessTokenFromStoarge = currentUserFromStorage['accessToken'];
    const headers = { 'token': accessTokenFromStoarge };

    let fileExtension = fileType;
    let input = filePath;

    return this.http.get(Examinees.downloadExamineeTemplate + "?fileName=" + input, {

      responseType: 'blob',
      observe: 'response',
      'headers': headers
    })
      .pipe(
        map((res: any) => {
          return new Blob([res.body], { type: fileExtension });
        })
      );
  }


  UploadExcel(formData: FormData, clientuuId: any) {
    const body = {
      "formData": formData,
      "clientuuId": clientuuId
    }
    return this.http.post<any>(Examinees.UploadExcel, body)
  }


  public upload(formData) {
    const currentUserFromStorage = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
    const accessTokenFromStoarge = currentUserFromStorage['accessToken'];
    const clientuuId = currentUserFromStorage?.clientuuId;
    const headers = { 'token': accessTokenFromStoarge };
    const httpOptions = { 'content-type': 'multipart/form-data; boundary=<calculated when request is sent>', 'headers': headers };
    return this.http.post(Examinees.upload + 'template?clientuuId=' + clientuuId, formData, httpOptions)
  }

  submitDescriptivEvalution(formData) {
    const currentUserFromStorage = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
    const accessTokenFromStoarge = currentUserFromStorage['accessToken'];
    const headers = { 'token': accessTokenFromStoarge };
    const httpOptions = { 'content-type': 'multipart/form-data; boundary=<calculated when request is sent>', 'headers': headers };
    return this.http.post(Examinees.DescriptiveEvaluation, formData, httpOptions)
  }

  getStatusList() {
    return this.http.get<any>(Examinees.statusList);
  }

  videoTutorial(assetGroup) {
    return this.http.get<any>(Training.tutorial + assetGroup);
  }
}
